import Vue from 'vue'

Vue.config.devtools = process.env.NODE_ENV === 'development'
Vue.config.productionTip = false
